import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import InviteSignup from "@/pages/InviteSignup";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import SmsConsent from "@/pages/SmsConsent";
import ResetPassword from "@/pages/ResetPassword";
import { Toaster } from "@/components/ui/sonner";
import logo from "@/assets/logo.png";

function Gate() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <img src={logo} alt="Short Stack Hawai'i" className="w-40 h-auto animate-pulse" />
      </div>
    );
  }
  return user ? <Dashboard /> : <Login />;
}

function App() {
  const path = typeof window !== "undefined" ? window.location.pathname : "/";
  const inviteMatch = path.match(/^\/invite\/([^/]+)/);
  if (inviteMatch) {
    return (
      <>
        <InviteSignup token={decodeURIComponent(inviteMatch[1])} />
        <Toaster position="top-center" />
      </>
    );
  }
  if (path === "/privacy") {
    return (<><PrivacyPolicy /><Toaster position="top-center" /></>);
  }
  if (path === "/terms") {
    return (<><Terms /><Toaster position="top-center" /></>);
  }
  if (path === "/sms-consent") {
    return (<><SmsConsent /><Toaster position="top-center" /></>);
  }
  if (path === "/reset-password") {
    return (<><ResetPassword /><Toaster position="top-center" /></>);
  }
  return (
    <AuthProvider>
      <Gate />
      <Toaster position="top-center" />
    </AuthProvider>
  );
}

export default App;
